import { render } from "./shipping-edit.vue?vue&type=template&id=5d469050"
import script from "./shipping-edit.vue?vue&type=script&lang=js"
export * from "./shipping-edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__